
import TickTock from './TickTock';

export default TickTock;
